import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import dataComponent from '../hoc/dataComponent';
import { defineMessages } from 'react-intl';
import classnames from 'classnames';
import { loadMoods } from '../actions/mood';
import * as clientActions from '../actions/client';

import { Link } from 'react-router';
import List from '../components/util/List';

import styles from './Moods.css';
import { META_TITLE_PREFIX } from '../constants';

const messages = defineMessages({
  metaTitle: {
    id: 'moods.meta.title',
    defaultMessage: 'Moods',
  },
  metaDescription: {
    id: 'moods.meta.description',
    defaultMessage:
      'Discover new classical music with our unique mood feature. We have the perfect soundtrack for you, hand-picked by our team of music experts.',
  },
});

class Moods extends Component {
  static propTypes = {
    moods: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
      })
    ),
  };

  static onDataFetch(store, params, location, intl) {
    store.dispatch(
      clientActions.setHelmet({
        title: META_TITLE_PREFIX + intl.formatMessage(messages.metaTitle),
        description: intl.formatMessage(messages.metaDescription),
        canonicalRoute: '/moods',
      })
    );
  }

  renderListItem = item => {
    const itemClasses = classnames(styles.listItem, styles[`listItem--${item.id}`]);

    return (
      <li className={styles.listElement} key={item.id}>
        <Link to={`/moods/${item.id}`} className={itemClasses}>
          <span className={styles.name}>{item.name}</span>
        </Link>
      </li>
    );
  };

  render() {
    return (
      <div className={classnames(styles.moods, 'u-page-container')}>
        <h1 className="sr-only">Moods</h1>
        <List className={styles.list} items={this.props.moods} renderItem={this.renderListItem} />
      </div>
    );
  }
}

function fetchData(store) {
  return store.dispatch(loadMoods());
}

function mapStateToProps(state) {
  return {
    entities: state.entities,
    listOfMoods: state.lists.moods,
  };
}

function mergeProps(stateProps, dispatchProps, ownProps) {
  const { entities, listOfMoods } = stateProps;

  return Object.assign({}, ownProps, dispatchProps, {
    moods: listOfMoods.entities.map(id => entities.moods[id]),
  });
}

export default compose(dataComponent(fetchData), connect(mapStateToProps, {}, mergeProps))(Moods);
